import { IStudentAccount, IStudentTestSession } from '../../ui-schooladmin/data/types';
import { IMappedList } from '../../ui-schooladmin/data/util';

export interface IClassroomArchivedTeachers {
    __id?: string,
    classroomId: string,
    timestamp: any,
    uid:string
  }
  export interface IUserInfo {
    uid: string,
    displayName: string,
  }
  export interface IClassroomSlot {
    id: string, 
    archiveId?: string, 
    name: string,
    isAssigned?:boolean
    curricShort?: string,
    classCode?: string,
    numStudents?: number,
    numTeachers?: number,
  }
   export interface IClassroom {
    id: string, 
    name:string;
    classCode?:string;
    isAssigned?:boolean
    curricShort?: string,
    owner?: string;
    enableClassListingByCC?: boolean;
    currentStudents?: IMappedList<IStudentAccount>,
    currentTeachers?: string[],
    openAssessments?: any[],
    scheduledAssessments?: any[],
    recentAssessments?: any[],
    timeCreated?: string;
    timeLastTouched?: string;
  }
  export interface IStudent {
    oen: string,
    firstname: string,
    lastname: string,
    accommodation:string
  }
  export interface IStudentList {
    studentAccount:IStudentAccount,
    is_online?: boolean,
    session_a?:ISession,
    session_b?:ISession
    
  }
  export interface ISession{
    is_active?:boolean,
    is_session_active:boolean,
    time_spent?:string
  }
  
  export interface ISessionBegin{
    slug: string,
    isScheduled:boolean,
    scheduled_time?:string[]
  }

  export enum ASSESSMENT {
    G9_SAMPLE = 'G9_SAMPLE',
    G9_OPERATIONAL = 'G9_OPERATIONAL',
    OSSLT_SAMPLE = 'OSSLT_SAMPLE',
    OSSLT_OPERATIONAL = 'OSSLT_OPERATIONAL',
    // OSSLT = 'Ontario Secondary School Literacy Test',
    // OSSLT_PRACTICE ='Sample Test (OSSLT)',
    // G9 = 'Grade 9 Assessment of Mathematics',
    // G9_PRACTICE = 'Sample Assessment (Grade 9)'
  }
  export enum SCHEDULER {
    NOW = 'NOW',
    LATER = 'LATER'
  }
export enum TeacherModal {
  SAMPLE_MODAL = 'SAMPLE_MODAL',
  EDIT_MODAL = 'EDIT_MODAL',
  SAMPLE_MODAL_OTHER = 'SAMPLE_MODAL_OTHER',
  REPORT_MODAL = "REPORT_MODAL",
  ALREADY_EXIST = "ALREADY_EXIST"
}

